import { render, staticRenderFns } from "./MiniUploadList.vue?vue&type=template&id=22261001&scoped=true"
import script from "./MiniUploadList.vue?vue&type=script&lang=js"
export * from "./MiniUploadList.vue?vue&type=script&lang=js"
import style0 from "./MiniUploadList.vue?vue&type=style&index=0&id=22261001&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22261001",
  null
  
)

export default component.exports